'use client'
import CookieBanner from '@/app/components/CookieBanner'
import { useMapView } from '@/app/hooks/useMapView'
import classNames from 'classnames'
import { NextIntlClientProvider, useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import { FC } from 'react'
import FooterNav from './FooterNav'
import Text from './common/Text'

export interface Props {
	mainPage?: boolean
	hotelPage?: boolean
	lang: string
	messages: Record<string, any>
}

const FooterContainer = ({ currentYear }: { currentYear: number }) => {
	const t = useTranslations('Footer')

	return (
		<div className="container mx-auto">
			<CookieBanner />
			<FooterNav />
			<div
				className="text-left rtl:text-right md:rtl:text-center md:text-center text-text-800 text-xs md:text-sm py-8 md:py-6"
				dangerouslySetInnerHTML={{
					__html: t('description', {
						breakOnMobile: '<br class="lg:hidden"/>',
					}),
				}}
			/>

			<Text
				size="sm"
				color="text-500"
				className="uppercase leading-none text-left md:text-center block rtl:max-md:text-right"
			>
				{t('copyRight', { year: currentYear })}
			</Text>
		</div>
	)
}

const FooterClient: FC<Props> = ({ mainPage, messages }) => {
	const currentYear = new Date().getFullYear()
	const { isFullScreenMap } = useMapView();

	if (sessionStorage?.getItem('hotelsMapView') === '0' || !sessionStorage?.getItem('hotelsMapView')) {
		return (
			<NextIntlClientProvider locale="en" messages={messages}>
				<footer
					className={classNames(
						'bg-white mt-8 xl:mt-11 max-lg:pt-6 max-lg:pb-8 md:py-10 md:px-3 relative rounded-t-4xl',
						{
							'lg:mt-[64px]': !mainPage,
							'hidden': isFullScreenMap
						}
					)}
				>
					<FooterContainer currentYear={currentYear} />
				</footer>
			</NextIntlClientProvider>
		)
	}
	return null;
}

export default dynamic(() => Promise.resolve(FooterClient), { ssr: false })
